import { useOrganizationStore } from '~/store/organization';
import { useAccountStore } from '~/store/account';
import { useBusinessesStore } from '~/store/businesses';

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.name === 'auth-logout' || to.name === 'auth-login') {
    return;
  }

  const organizationStore = useOrganizationStore();
  const { organization } = storeToRefs(organizationStore);
  const accountStore = useAccountStore();
  const { currentAccount } = storeToRefs(accountStore);

  if (
    to.name !== 'welcome-screen' &&
    organization.value?.isWelcomeScreenEnabled &&
    currentAccount.value?.welcomeScreenClosedAt === null
  ) {
    return navigateTo('/welcome-screen');
  } else if (
    to.name === 'welcome-screen' &&
    currentAccount.value?.welcomeScreenClosedAt
  ) {
    return navigateTo('/');
  }

  if (
    !currentAccount.value ||
    !organization.value?.isBusinessesEnabled ||
    !organization.value?.organizationSettings?.businessSelectorEnabled
  ) {
    return;
  }

  const businessesStore = useBusinessesStore();

  const { selectedBusiness, businessesCount } = storeToRefs(businessesStore);

  await businessesStore.initialize();

  if (businessesCount.value < 2 && to.name === 'business-selection') {
    return navigateTo('/');
  }

  if (
    to.name !== 'business-selection' &&
    !selectedBusiness.value &&
    businessesCount.value > 1
  ) {
    return navigateTo('/business-selection');
  }
});
